module.exports = __webpack_public_path__ + "img/logo.c8934349.png";